export enum ThemeVariant {
  HUSA = 'husa',
  BLOMA = 'bloma',
  ISKRAFT = 'iskraft',
}
